var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTsechoose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160.24 96.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d1d1b;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_2",
    "data-name": "katman 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "katman_1-2",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.36,89.32,147.68,48,79.25,7.58,12.34,48.94l67,40.38ZM79.15,0l81.09,47.86-80.88,49L0,49.05,79.15,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "60.2 35.73 39.95 35.73 39.95 42.23 46.34 42.23 46.34 61.93 53.16 61.93 53.16 42.23 60.2 42.23 60.2 35.73 60.2 35.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "117.91 41.47 117.91 34.86 99.5 34.86 99.5 61.39 117.91 61.39 117.91 55.33 106 55.33 106 51.65 112.28 51.65 112.28 45.04 106 45.04 106 41.47 117.91 41.47 117.91 41.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.35,52.51a13.4,13.4,0,0,1,4.11,9.64,13.21,13.21,0,1,1-26.41,0v-.33h7v.33a6.18,6.18,0,1,0,10.18-4.66L70.16,44.93a13.83,13.83,0,0,1-4.11-9.74,13.21,13.21,0,1,1,26.41,0v.32h-7v-.32a6.18,6.18,0,0,0-12.35,0,6.14,6.14,0,0,0,1.41,3.9L88.35,52.51Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTsechoose);
export default __webpack_public_path__ + "static/media/tsechoose.addc0c6f7309a8532d28b30f29ac6d2d.svg";
export { ForwardRef as ReactComponent };